export default "__VITE_ASSET__D4aub6lt__"